export default __webpack_public_path__ + "./fonts/print-solid.8156b394.svg";